import React from 'react';

import ReconnectingWebSocket from 'reconnecting-websocket';

import {
    Card,
    ChipDelete,
    CircularProgress,
    Dropdown,
    Menu,
    MenuButton,
    Modal, ModalClose,
    ModalDialog,
    Stack,
} from "@mui/joy";
import Box from "@mui/joy/Box";
import IconButton from "@mui/joy/IconButton";
import Button from "@mui/joy/Button";
import Divider from "@mui/joy/Divider";
import Chip from "@mui/joy/Chip";
import Typography from "@mui/joy/Typography";
import Avatar from "@mui/joy/Avatar";
import Snackbar from "@mui/joy/Snackbar";


import showdown from "showdown";

// components
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import Message from "./Message";
import MessageContent from "./MessageContent";
import RoomStickers from "./RoomStickers";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import RoomSubscribers from "./RoomSubscribers";
import CommonForm from "../Common/CommonForm";
import {retrieveImage} from "../../utils/misc";
import RoomAttachments from "./RoomAttachments";
import AudioCapture from "./AudioCapture";
import MessageAttachmentCreateModal from "./MessageAttachmentCreateModal";
import {extractTextFromFile} from "./utils";


// icons
import TelegramIcon from "@mui/icons-material/Telegram";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import ImageIcon from "@mui/icons-material/Image";
import SearchIcon from "@mui/icons-material/Search";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteIcon from '@mui/icons-material/Delete';


const emojis = [
    '😊', '👍', '👎', '🤝', '👌', '🔥', '😂',
    '✨', '🧨', '🤔', '🤯', '👺', '💩', '⚡',
    '🤡', '👀', '🙄', '😂', '🙏', '🤣', '💯',
    '🙈', '🙉',
    '🙊', '😳', '🤗', '😇', '👍', '👎', '🌟'
]


function getFileExtension(filename) {
  return filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2);
}


class Room extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);

        this.messageRefs = {}

        this.state = {
            room: null,
            roomSubscriber: this.props.roomSubscriber,
            roomSubscribers: null,
            avatars: {},
            messages: [],
            replyTo: null,
            attachments: [],
            isAuthenticated: false,
            stickerPad: false,
            subscriberPad: false,
            attachmentsPad: false,
            page: 1,
            pages: null,
            searchModal: false,
            searchList: [],
            inputBlocked: false,
            snackbarOpen: false,
            snackbarText: '',
            agent: null,
            agentContext: false,
        }
        this.parser = new showdown.Converter(
            {
                tables: true,
                noHeaderId: true,
                simplifiedAutoLink: true,
                openLinksInNewWindow: true,
            }
        )

    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.roomSubscriber.id !== this.props.roomSubscriber.id) {
            await this.refresh()
        }
        document.removeEventListener(
            'paste',
            this.handlePasteEvent.bind(this)
        )
        document.addEventListener('paste' +
            'paste',
            this.handlePasteEvent.bind(this)
        );
    }

    async componentDidMount() {
        document.addEventListener('' +
            'paste',
            this.handlePasteEvent.bind(this)
        );
        await this.refresh()
    }

    async refresh() {
        if (this.props.roomSubscriber) {
            await this.retrieveRoom();
            await this.retrieveMessages();
            this.client = new ReconnectingWebSocket(
                `${process.env.REACT_APP_WS_HOST}/ws/room/${this.props.roomSubscriber.room.id}/`,
            );
            this.client.onopen = () => {
                this.authenticateWS();
                console.log("WebSocket Client Connected");
            };
            this.client.onclose = () => {
                console.log("WebSocket Client Disconnected");
            }
            this.client.onmessage = (message) => {
                this.handleMessage(message);
            };
            this.chat_timer = setInterval(() => (
                    this.pingWS()),
                5000
            );
        }
    }

    authenticateWS() {
        let tokens;
        if (typeof localStorage.getItem("authTokens") === 'string') {
            tokens = JSON.parse(localStorage.getItem("authTokens"));
        } else {
            tokens = localStorage.getItem("authTokens");
        }
        this.client.send(JSON.stringify({
            type: 'authenticate',
            access_token: tokens.access,
            refresh_token: tokens.refresh
        }));
        this.setState({
            isAuthenticated: true
        })
    }

    pingWS() {
        if (!this.state.isAuthenticated) {
            this.authenticateWS()
        }
        this.client.send(JSON.stringify({type: "ping"}))
    }

    handleMessage(message) {
        let data
        if (typeof message.data === 'string') {
            data = JSON.parse(message.data);
        } else {
            data = message.data;
        }

        switch (data.type) {
            case 'auth_success':
                console.log('Authenticated as', data.username);
                if (data.new_access_token) {
                    let tokens = JSON.parse(localStorage.getItem("authTokens"));
                    if (data.access_token) {
                        tokens.access = data.access_token;
                    }
                    localStorage.setItem('authTokens', JSON.stringify(tokens));
                }
                break;

            case 'auth_error':
                console.error('Auth Error:', data.message);
                this.socket.close();
                break;

            case 'message':
                this.setState((state) => ({
                    messages: [
                        data,
                        ...state.messages,
                    ],
                }));
                this.messageRefs[data.id.toString()] = React.createRef();
                break;

            case 'reaction':
                if (this.messageRefs[data.message.toString()]) {
                    if (data.direction === 'add') {
                        this.messageRefs[data.message.toString()].current.addReaction(data.value);
                    } else if (data.direction === 'delete') {
                        this.messageRefs[data.message.toString()].current.deleteReaction(data.value);
                    }
                }
                break;

            case 'delete':
                this.messageRefs[data.message.toString()].current.markMessageDeleted();
                break;

            case 'error':
                console.error('Server Error:', data.message);
                break;
        }
    }

    componentWillUnmount() {
        if (this.chat_timer) {
            clearInterval(this.chat_timer);
        }
        if (this.client) {
            this.client.close();
        }
        document.removeEventListener(
            'paste',
            this.handlePasteEvent.bind(this)
        )
    }

    handlePasteEvent(event) {
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;
        for (let i = 0; i < items.length; i++) {
            if (items[i].kind === 'file') {
                const file = items[i].getAsFile();
                this.addAttachment(file);
            }
        }
    }

    async retrieveMessages() {
        const url = 'message/';
        const api = new BaseApi();
        let params = {
            room: this.props.roomSubscriber.room.id,
            page: this.state.page,
            deleted: false,
            page_size: 20,
        };
        let response = await api.get(
            url,
            params
        );
        for (const message of response.data.results) {
            this.messageRefs[message.id] = React.createRef();
        }
        this.setState(
            {
                messages: [
                    ...this.state.messages,
                    ...response.data.results,
                ],
                page: this.state.page + 1,
                pages: response.data.total_pages,
            }
        );
    }

    async readAll() {
        const url = `room_subscriber/${this.props.roomSubscriber.id}/read_all`;
        const api = new BaseApi();
        await api.get(
            url,
            {}
        );
    }

    setText(text) {
        this.setState(
            {
                text: text,
            }
        );
    }

    setAgent(agent) {
        console.log(agent)
        if (agent === this.state.agent){
            this.setState(
                {
                    agent: null
                }, () => {console.log(this.state)}
            )
        }
        else(
            this.setState(
                {
                    agent: agent
                }, () => {console.log(this.state)}
            )
        )

    }

    setAgentContext() {
        this.setState(
            {
                agentContext: !this.state.agentContext
            }, () => {console.log(this.state)}
        )
    }

    setRead(messageId) {
        if (this.client) {
            if (!this.state.isAuthenticated) {
                this.authenticateWS()
            }
            this.client.send(
                JSON.stringify(
                    {
                        type: "read_by",
                        message: messageId,
                        read_by: this.context.subscriberObject.id,
                    }
                )
            )
        }
    }

    setReaction(messageId, value) {
        if (this.client) {
            if (!this.state.isAuthenticated) {
                this.authenticateWS()
            }
            this.client.send(
                JSON.stringify(
                    {
                        type: "reaction",
                        message: messageId,
                        value: value,
                        owner: this.context.subscriberObject.id,
                        direction: 'add',
                    }
                )
            )
        }
    }

    deleteReaction(messageId, value) {
        if (this.client) {
            if (!this.state.isAuthenticated) {
                this.authenticateWS()
            }
            this.client.send(
                JSON.stringify(
                    {
                        type: "reaction",
                        message: messageId,
                        value: value,
                        owner: this.context.subscriberObject.id,
                        direction: 'delete',
                    }
                )
            )
        }
    }

    snackbarCallback(open, text){
        this.setState(
            {
                snackbarOpen: open,
                snackbarText: text,
            }
        );
    }

    async postMessage() {

        let textarea = document.getElementById('chat_textarea')
        let content = textarea.value

        this.setState(
            {
                inputBlocked: true,
            }
        );

        if (this.props.roomSubscriber.room.xtype === 'BOT') {
            let attachmentsText = ''
            for (let attachment of this.state.attachments) {
                if (['docx', 'pdf', 'jpeg', 'jpg', 'png', 'webp', 'bmp', 'gif', 'wav', 'mp3', 'webm', 'ogg', 'm4a'].includes(getFileExtension(attachment.name))) {
                    let attachmentText = await extractTextFromFile(
                        attachment,
                        this.props.roomSubscriber.room.id,
                        this.snackbarCallback.bind(this)
                    )
                    attachmentsText += `### ФАЙЛ: ${attachment.name} \n\n **СОДЕРЖАНИЕ**: \n\n ${attachmentText} ;`
                }
            }
            if (this.state.attachments.length){
                content = '## Системный промпт: \n\n Используй следующие полученные данные, чтобы ответить на вопрос пользователя полностью и точно. ' +
                'Всегда указывай источник информации, если он указан. \n\n' +
                '## Контекст: \n\n' +
                attachmentsText + '\n\n' + '## Вопрос пользователя: \n\n' + content
            }
        }

        let data = {
            content: content,
            agent: this.state.agent,
            agent_context: this.state.agentContext,
            room: this.props.roomSubscriber.room.id,
            reply_to: this.state.replyTo?.id,
        };
        const api = new BaseApi();
        let url = 'message/'
        let response = await api.post(
            url,
            data
        );
        if (response.status === 201) {
            if (this.props.roomSubscriber.room.xtype !== 'BOT') {
                for (let attachment of this.state.attachments) {
                    let formData = new FormData();
                    formData.append('room', this.props.roomSubscriber.room.id);
                    formData.append('xtype', 'UPLOAD');
                    formData.append('upload', attachment);
                    await api.post(
                        url,
                        formData
                    );
                }
            }

            this.setState(
                {
                    replyTo: null,
                    attachments: [],
                    inputBlocked: false,
                    agent: null,
                }
            );
            textarea.value = ''
        }
    }

    addEmoji(event) {
        let textarea = document.getElementById('chat_textarea')
        const cursor_pos = textarea.selectionStart;
        const current_text = textarea.value;

        textarea.value = current_text.substring(0, cursor_pos) + event.target.textContent + current_text.substring(cursor_pos);
        textarea.selectionStart = cursor_pos + 2;
        textarea.selectionEnd = cursor_pos + 2;

        textarea.focus()
    }

    async addSticker(sticker) {
        const api = new BaseApi();
        let url = 'message/'
        let data = {
            room: this.props.roomSubscriber.room.id,
            content: sticker,
            xtype: 'STICKER'
        }
        await api.post(
            url,
            data
        );
    }

    reply(message) {
        this.setState(
            {
                replyTo: message,
            },
            () => {
                setTimeout(() => {
                    const textarea = document.getElementById('chat_textarea');
                    textarea.focus();
                }, 100);
            }
        );
    }

    async suspend() {
        const url = `room_subscriber/${this.props.roomSubscriber.id}/`;
        const api = new BaseApi();
        await api.delete(
            url,
        );
    }

    async retrieveRoom() {
        const api = new BaseApi();
        this.setState({
            room: null,
        });
        let url = `room/${this.props.roomSubscriber.room.id}`;
        let params = {};
        let response = await api.get(
            url,
            params
        );
        let room = response.data;
        url = 'room_subscriber/'
        params = {
            room: room.id,
            page_size: 10000,
            active: true,
        };
        response = await api.get(
            url,
            params,
        );
        let roomSubscribers = response.data.results;
        let avatars = {};
        for (let roomSubscriber of roomSubscribers) {
            let avatar = await retrieveImage(
                'Subscriber',
                'image',
                roomSubscriber.subscriber.id
            );
            avatars[roomSubscriber.subscriber.id] = avatar ? avatar : ''
        }
        this.setState({
            room: room,
            roomSubscribers: roomSubscribers,
            avatars: avatars,
            page: 1,
            messages: [],
        });
    }

    handleDrop(event) {
        event.preventDefault();
        const files = event.dataTransfer.files;
        if (files && files.length > 0) {
            let attachments = this.state.attachments
            attachments.push(files[0])
            this.setState(
                {
                    attachments: attachments
                }
            )
        }
    }

    handleDragOver(event) {
        event.preventDefault();
    }

    async handleKeyDown(event) {
        if (event.ctrlKey && event.key === 'Enter') {
            event.preventDefault(); // Prevent default behavior (like form submission)
            await this.postMessage();
        }
    };

    deleteAttachment(index) {
        let attachments = this.state.attachments
        const newAttachments = attachments.filter((_, i) => i !== index);
        this.setState({
            attachments: newAttachments
        })
    }

    toggleStickerPad() {
        this.setState({
            stickerPad: !this.state.stickerPad,
        })
    }

    toggleSubscriberPad() {
        this.setState({
            subscriberPad: !this.state.subscriberPad,
        })
    }

    toggleAttachmentsPad() {
        this.setState({
            attachmentsPad: !this.state.attachmentsPad,
        })
    }

    async processSearch(form) {
        this.setState(
            {
                searchList: [],
            }
        );
        let formDataObj = Object.fromEntries(form.state.formData.entries());
        const url = 'message/';
        const params = {
            room: this.props.roomSubscriber.room.id,
            deleted: false,
            page_size: 10000,
            content: formDataObj.query
        };
        const api = new BaseApi();
        let response = await api.get(
            url,
            params,
            'repeat'
        );
        this.setState(
            {
                searchList: response.data.results,
            }
        );
    }

     addAttachment(file) {
        let attachments = this.state.attachments
        attachments.push(file)
        this.setState(
            {
                attachments: attachments
            }
        )
    }

    saveRecording(blob) {
        let file = new File([blob], 'capture.webm', {
            type: 'webm',
            lastModified: Date.now()
        });
        this.addAttachment(file)
    }

    render() {
        if (!this.props.roomSubscriber) {
            return <></>
        }
        if (!this.state.room || !this.state.messages || !this.state.avatars) {
            return (
                <CircularProgress/>
            )
        }
        return (
            <Stack
                direction={'row'}
                spacing={2}
                sx={{
                    maxHeight: '100%',
                    overflowY: 'hidden',
                    height: '100%',
                }}
            >

                <Stack
                    sx={{
                        flexDirection: 'column',
                        flexGrow: 3,
                        height: '100%',
                        maxHeight: '100%',
                        alignItems: 'stretch',
                        justifyContent: "space-between",
                        overflowY: 'hidden',

                    }}
                    onDrop={this.handleDrop.bind(this)}
                    onDragOver={this.handleDragOver.bind(this)}
                >
                    <Card
                        size={'sm'}
                        variant={'soft'}
                        sx={{
                            mb: 2
                        }}
                    >
                        <Stack
                            direction={'row'}
                            useFlexGap
                            sx={{
                                flexWrap: 'wrap',
                            }}
                            alignItems={'center'}
                            spacing={1}
                        >
                            <IconButton
                                sx={{
                                    display: {
                                        xs: 'flex',
                                        lg: 'none'
                                    }
                                }}
                                onClick={this.props.menuCallBack}
                            >
                                {'<'}
                            </IconButton>
                            <Avatar
                                color={'primary'}
                            >
                                {this.state.roomSubscriber.room.xtype === 'ONETOONE' ? this.state.roomSubscriber.title.slice(0, 2) : this.state.roomSubscriber.room.title.slice(0, 2)}
                            </Avatar>
                            <Typography>
                                <strong>{this.state.roomSubscriber.room.xtype === 'ONETOONE' ? this.state.roomSubscriber.title : this.state.room.title}</strong>
                            </Typography>
                            <CommonCallBackButton
                                callBack={this.readAll.bind(this)}
                                icon={VisibilityIcon}
                                // label={'Прочитать все'}
                                color={'neutral'}
                                variant={'soft'}
                                flat={true}
                            />
                            {
                                this.state.roomSubscriber.room.xtype !== 'ONETOONE' ?
                                    <CommonCallBackButton
                                        callBack={this.toggleSubscriberPad.bind(this)}
                                        icon={PeopleOutlineIcon}
                                        // label={'Участники'}
                                        color={'neutral'}
                                        variant={this.state.subscriberPad ? 'solid' : 'soft'}
                                        flat={true}
                                    /> :
                                    null
                            }
                            <CommonCallBackButton
                                callBack={this.toggleAttachmentsPad.bind(this)}
                                icon={AttachFileIcon}
                                // label={'Вложения'}
                                color={'neutral'}
                                variant={this.state.attachmentsPad ? 'solid' : 'soft'}
                                flat={true}
                            />
                            <IconButton
                                size={'sm'}
                                onClick={() => {
                                    this.setState({searchModal: true})
                                }}
                                variant={'soft'}
                                sx={{
                                    p: 0
                                }}
                            >
                                <SearchIcon
                                    sx={{
                                        fontSize: '16px',
                                    }}
                                />
                            </IconButton>
                            {
                                this.state.roomSubscriber.room.xtype !== 'ONETOONE' ?
                                <CommonCallBackButton
                                    callBack={this.suspend.bind(this)}
                                    icon={DeleteIcon}
                                    // label={'Вложения'}
                                    color={'warning'}
                                    flat={true}
                                />: null
                            }
                            <Modal
                                open={this.state.searchModal}
                            >
                                <ModalDialog
                                    layout={'center'}
                                    size="sm"
                                >
                                    <ModalClose
                                        onClick={() => {
                                            this.setState(
                                                {
                                                    searchModal: false,
                                                    searchList: [],
                                                }
                                            )
                                        }}
                                    />
                                    <Box
                                        sx={{
                                            overflowY: 'scroll',
                                            pr: 2,
                                            minWidth: '80vw'
                                        }}
                                    >
                                        <CommonForm
                                            fields={
                                                [
                                                    {
                                                        'name': 'query',
                                                        'label': 'Запрос',
                                                        'xs': 12,
                                                        'sm': null,
                                                        'md': null,
                                                        'lg': null,
                                                        'xl': null,
                                                        'required': true,
                                                        'default': this.state.query,
                                                        'type': 'input',
                                                    },
                                                    {
                                                        'type': 'submit',
                                                        'label': 'Искать',
                                                    }
                                                ]
                                            }
                                            processForm={this.processSearch.bind(this)}
                                        />
                                        <Stack
                                            spacing={1}
                                        >
                                            {this.state.searchList.map((m) => (
                                                <Message
                                                    message={m}
                                                    subscriberObject={this.context.subscriberObject}
                                                    key={'MessageSearch' + m.id}
                                                    readCallBack={this.setRead.bind(this)}
                                                    reactionCallBack={this.setReaction.bind(this)}
                                                    deleteReactionCallBack={this.deleteReaction.bind(this)}
                                                    parser={this.parser}
                                                    emojis={emojis}
                                                    avatars={this.state.avatars}
                                                />)
                                            )}
                                        </Stack>
                                    </Box>
                                </ModalDialog>
                            </Modal>
                        </Stack>
                    </Card>
                    <Stack
                        direction={'column-reverse'}
                        spacing={2}
                        sx={{
                            width: '100%',
                            alignItems: 'flex-end',
                            overflowY: 'auto',
                            maxHeight: '100%',
                            flexGrow: 30,
                            mb: 2,
                            flexWrap: 'nowrap',
                            pr: 1,
                        }}
                        id={'MessengerScrollableArea'}
                    >
                        {
                            this.state.messages.map(message => (
                                    <Message
                                        ref={this.messageRefs[message.id]}
                                        key={'Message' + message.id}
                                        message={message}
                                        subscriberObject={this.context.subscriberObject}
                                        readCallBack={this.setRead.bind(this)}
                                        reactionCallBack={this.setReaction.bind(this)}
                                        deleteReactionCallBack={this.deleteReaction.bind(this)}
                                        parser={this.parser}
                                        replyCallBack={this.reply.bind(this)}
                                        emojis={emojis}
                                        avatars={this.state.avatars}
                                        allowEdit={true}
                                    />
                                )
                            )
                        }
                        {
                            this.state.page - 1  < this.state.pages ?
                                <Card
                                    onClick={this.retrieveMessages.bind(this)}
                                    size={'sm'}
                                    variant={'soft'}
                                    sx={{
                                        cursor: 'pointer'
                                    }}
                                >
                                    Загрузить еще ...
                                </Card> :
                                null
                        }
                    </Stack>
                    <Stack
                        spacing={1}
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexGrow: 1,
                        }}
                    >
                        <Stack
                            sx={{
                                width: '100%'
                            }}
                            spacing={1}
                        >
                            <Stack
                                direction={'row'}
                                spacing={1}
                                sx={{
                                    flexWrap: 'wrap',
                                    alignItems: 'center'
                                }}
                            >
                                <Dropdown>
                                    <MenuButton
                                        variant="plain"
                                        size="sm"
                                    >
                                        {emojis[0]} Emoji
                                    </MenuButton>
                                    <Menu
                                        variant="soft"
                                        size="sm"
                                        sx={{
                                            width: '200px',
                                            display: 'flex',
                                            flexFlow: 'row wrap',
                                        }}
                                    >
                                        {emojis.map(e => (
                                            <IconButton
                                                variant="plain"
                                                color="neutral"
                                                onClick={this.addEmoji.bind(this)}
                                                key={'IconButton' + crypto.randomUUID()}
                                            >
                                                {e}
                                            </IconButton>
                                        ))}
                                    </Menu>
                                </Dropdown>
                                <Button
                                    onClick={this.toggleStickerPad.bind(this)}
                                    variant={this.state.stickerPad ? 'solid' : 'plain'}
                                    size={'sm'}
                                    color={'neutral'}
                                >
                                    🖼️ Стикеры
                                </Button>
                                <MessageAttachmentCreateModal
                                    callBack={this.addAttachment.bind(this)}
                                />
                            </Stack>
                            {
                                this.state.replyTo ?
                                    <Card
                                        variant={'soft'}
                                        size={'sm'}
                                        color={'neutral'}
                                        sx={{
                                            width: '100%',
                                            cursor: 'pointer'
                                        }}
                                        orientation="horizontal"
                                        onClick={this.reply.bind(this, null)}
                                    >
                                        <Divider
                                            color={'primary'}
                                            sx={{
                                                px: 0.2,
                                                writingMode: 'vertical-rl',
                                            }}
                                        >
                                            В ответ
                                        </Divider>
                                        <MessageContent
                                            message={this.state.replyTo}
                                            isMyMessage={false}
                                            isRead={true}
                                            parser={this.parser}
                                            trim={true}
                                        />
                                    </Card> :
                                    null
                            }
                            <Stack
                                direction={'row'}
                                spacing={1}
                                sx={{
                                    width: '100%',
                                    overflowX: 'scroll',
                                }}
                            >
                                {this.state.attachments.map((attachment, index) => (
                                    <Chip
                                        startDecorator={<AttachFileIcon/>}
                                        key={'AttachmentChip' + crypto.randomUUID()}
                                        endDecorator={
                                            <ChipDelete
                                                onClick={this.deleteAttachment.bind(this, index)}
                                            />
                                        }
                                    >
                                        {attachment.name}
                                    </Chip>
                                ))}
                            </Stack>
                        </Stack>
                        <textarea
                            id={'chat_textarea'}
                            onKeyDown={this.handleKeyDown.bind(this)}
                            style={{
                                minHeight: '120px',
                                height: 'auto',
                                border: '1px solid rgba(159, 166, 173, 0.5)',
                                borderRadius: '8px',
                                outline: 'none',
                                padding: '8px',
                                background: 'transparent',
                                ':focus': {
                                    border: '1px solid #007bff',
                                    boxShadow: '0 0 0 3px rgba(0, 123, 255, 0.1)',
                                },
                                fontFamily: 'var(--joy-fontFamily-body, Roboto)',
                                fontSize: '16px',
                            }}
                            disabled={this.state.inputBlocked}
                        />
                        <Stack
                            direction={'row'}
                            sx={{
                                alignItems: "center",
                            }}
                            spacing={1}
                        >
                            <Button
                                size={'sm'}
                                color="primary"
                                onClick={this.postMessage.bind(this)}
                                endDecorator={<TelegramIcon/>}
                                disabled={this.state.inputBlocked}
                            >
                                Отправить
                            </Button>
                            <AudioCapture
                                saveCallBack={this.saveRecording.bind(this)}
                            />
                            <Stack
                                direction={'row'}
                                sx={{
                                    alignItems: "center",
                                }}
                                spacing={1}
                            >
                                {this.state.roomSubscriber.room.bot?.agents?.map((agent) => (
                                    <Button
                                        key={'RadioAgent' + agent.id}
                                        variant={this.state.agent === agent.id ? 'solid' : 'plain'}
                                        color={this.state.agent === agent.id ? 'warning' : 'neutral'}
                                        onClick={() => {
                                            this.setAgent(agent.id)
                                        }}
                                    >

                                        {this.state.agent === agent.id ? <CheckCircleIcon /> : null} {agent.short_title}
                                    </Button>
                                ))}
                                {
                                    this.state.roomSubscriber.room.bot?.agents.length?
                                        <Button
                                            key={'RadioAgentContext'}
                                            variant={this.state.agentContext? 'solid' : 'plain'}
                                            color={this.state.agentContext? 'warning' : 'neutral'}
                                            onClick={() => {
                                                this.setAgentContext()
                                            }}
                                        >

                                            {this.state.agentContext ? <CheckCircleIcon /> : null} Учитывать контекст
                                        </Button>:
                                        null
                                }
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack
                    sx={{
                        display: !this.state.stickerPad ? 'none' : null,
                        width: '300px',
                        // flexGrow: 1,
                        transition: 'transform 0.4s',
                    }}
                >
                    <Card
                        size={'sm'}
                        variant={'soft'}
                        sx={{
                            mb: 2,
                            width: '300px'
                        }}
                    >
                        <Stack
                            direction={'row'}
                            useFlexGap
                            sx={{
                                flexWrap: 'wrap',
                            }}
                            alignItems={'center'}
                            spacing={1}
                        >
                            <Avatar
                                color={'primary'}
                            >
                                <ImageIcon/>
                            </Avatar>
                            <Typography
                                sx={{
                                    m: 1.7
                                }}
                            >
                                <strong>
                                    Стикеры
                                </strong>
                            </Typography>
                        </Stack>
                    </Card>
                    <RoomStickers
                        key={'RoomStickers' + this.state.roomSubscriber.id}
                        roomSubscriber={this.state.roomSubscriber}
                        addStickerCallback={this.addSticker.bind(this)}
                    />
                </Stack>
                <Stack
                    sx={{
                        display: !this.state.subscriberPad ? 'none' : null,
                        width: '450px',
                        // flexGrow: 1,
                        transition: 'transform 0.4s',
                    }}
                >
                    <Card
                        size={'sm'}
                        variant={'soft'}
                        sx={{
                            mb: 2,
                            width: '450px'
                        }}
                    >
                        <Stack
                            direction={'row'}
                            useFlexGap
                            sx={{
                                flexWrap: 'wrap',
                            }}
                            alignItems={'center'}
                            spacing={1}
                        >
                            <Avatar
                                color={'primary'}
                            >
                                <PeopleOutlineIcon/>
                            </Avatar>
                            <Typography
                                sx={{
                                    my: 1.7
                                }}
                            >
                                <strong>
                                    Участники
                                </strong>
                            </Typography>
                        </Stack>
                    </Card>
                    <RoomSubscribers
                        key={'RoomSubscribers' + this.state.roomSubscriber.id}
                        room={this.state.room}
                        roomSubscriber={this.state.roomSubscriber}
                    />
                </Stack>
                <Stack
                    sx={{
                        display: !this.state.attachmentsPad ? 'none' : null,
                        width: '300px',
                        // flexGrow: 1,
                        transition: 'transform 0.4s',
                    }}
                >
                    <Card
                        size={'sm'}
                        variant={'soft'}
                        sx={{
                            mb: 2,
                            width: '300px'
                        }}
                    >
                        <Stack
                            direction={'row'}
                            useFlexGap
                            sx={{
                                flexWrap: 'wrap',
                            }}
                            alignItems={'center'}
                            spacing={1}
                        >
                            <Avatar
                                color={'primary'}
                            >
                                <AttachFileIcon/>
                            </Avatar>
                            <Typography
                                sx={{
                                    my: 1.7
                                }}
                            >
                                <strong>
                                    Вложения
                                </strong>
                            </Typography>
                        </Stack>
                    </Card>
                    <RoomAttachments
                        key={'RoomAttachments' + this.state.roomSubscriber.id}
                        room={this.state.room}
                        roomSubscriber={this.state.roomSubscriber}
                    />
                </Stack>
                <Snackbar
                    anchorOrigin={{
                        'vertical': 'top',
                        'horizontal': 'center'
                    }}
                    open={this.state.snackbarOpen}
                    key={'Snackbar' + this.state.roomSubscriber.id}
                    onClose={() => {
                        this.snackbarCallback(false, '')
                    }}
                >
                    {this.state.snackbarText}
                </Snackbar>
            </Stack>
        )
    }
}

export default Room;